import React, {  useEffect } from "react";
import { Link } from "react-router-dom";
import FormComponent from "./FormComponent";
import TabComponent from "./TabComponent";
import "./style.scss";
import { convertDateTime } from "../../utils/date-time";
import { useAuth } from "../../contexts/auth";
import UsingIntl from "../../services/using_intl";
import { formatMessage } from "devextreme/localization";
import LoadPanel from "devextreme-react/load-panel";
import { showEmployeeByOid } from "../../redux/actions";
import { responseEmployee } from "../../redux/reducers";
import { useDispatch, useSelector } from "react-redux";

export default function Employee() {
  const dispatch = useDispatch();
  const { user } = useAuth();
  const { employee, loading } = useSelector(responseEmployee);

  useEffect(() => {
    UsingIntl("P0029");
  }, []);

  useEffect(() => {
    if (!user.EmployeeOid) {
      window.location.reload();
      return;
    }
    dispatch(showEmployeeByOid(user?.EmployeeOid));
  }, [dispatch, user]);

  return (
    <div>
      <LoadPanel visible={loading} />
      {/* Breadcrumb */}
      <div className={"breadcrumb"}>
        <div className={"breadcrumb-left"}>
          <div className={"breadcrumb-page-title"}>
            {formatMessage("Employee")}
          </div>
        </div>
        <div className={"breadcrumb-right"}>
          <Link to="/employee-detail" className={"breadcrumb-item"}>
            {formatMessage("Default")}
          </Link>
          <span className={"breadcrumb-item active"}>
            {formatMessage("PersonalInformation")}
          </span>
        </div>
      </div>
      <div className={"section"}>
        <div className={"section-heading has-page-title"}>
          <h4 className={"page-title d-flex align-item-center"}>
            <img
              src={
                employee.AvatarImage
                  ? `data:image/jpeg;base64,${employee.AvatarImage}`
                  : "/assets/images/avatar-2.png"
              }
              alt=""
              width={"50px"}
              className="mr-2"
              loading="lazy"
            />
            <span>
              {employee.EmployeeCode} - {employee.FullName}
            </span>
          </h4>
        </div>
        <div className={"section-body"}>
          {employee.Department && employee.Position && (
            <div>
              <FormComponent
                convertDateTime={convertDateTime}
                employee={employee}
              />
              <TabComponent
                convertDateTime={convertDateTime}
                employee={employee}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
